import Spinner from 'nucleus-core/progress/Spinner';
import SpinnerStyle from 'nucleus-core/less/cv/Process.less';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';

export default function LoadingIndicator(props) {
  const { spinnerMessage, message } = props;
  return (
    <div {...resolve(props, 'loadingMessage')}>
      <Spinner
        classes={SpinnerStyle}
        fallbackText={spinnerMessage}
      />
      { message &&
        <div>
          <p {...resolve(props, 'loadingMessageText')}>
            {message}
          </p>
        </div>
      }
    </div>
  );
}
LoadingIndicator.propTypes = {
  spinnerMessage: PropTypes.string,
  message: PropTypes.string
};
